import { useEffect, useRef, useState } from "react";
import "./Toolbar.css";
import { FaBars, FaUserCircle, FaSearch } from "react-icons/fa";

import logo from "../../../logo.png";
import "bootstrap-icons/font/bootstrap-icons.css";
import axios from "../../../utils/axiosInstance";
import Modal from "../../../components/modal/Modal";

import SideDrawer from "../SideDrawer/SideDrawer";

import ViewAllCategories from "../../../components/category/ViewAllCategories";
import LinearLayout from "../../../components/layout/LinearLayout";
import { useCart } from "../../../utils/CartContext";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Login from "../../../components/form/login/login";

const Toolbar = ({ forceLogin }) => {
  const [showModal, setShowModal] = useState(false);
  const [openSideDrawer, setOpenSideDrawer] = useState(false);
  const [tree, setTree] = useState([]);
  const [cartCount, setCartCount] = useState(0);
  const [searchText, setSearchText] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [categories, setCategories] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [title, setTitle] = useState("My shop");
  const [sitelogo, setSiteLogo] = useState("");
  const { cartItems } = useCart();
  const navigate = useNavigate();
  const inputRef = useRef();
  const token = localStorage.getItem("token");

  useEffect(() => {
    if (forceLogin) setShowModal(true);
  }, [forceLogin]);

  // 📦 دریافت دسته‌بندی‌ها
  useEffect(() => {
    axios.get("/categories?limit=1000").then((res) => {
      if (res.data.status) {
        setTree(buildTree(res.data.categories));
      }
    });
    axios.get("/categories/leaves").then((res) => {
      if (res.data.status) {
        setCategories(res.data.leafCategories);
      }
    });
  }, []);

  function buildTree(list) {
    const map = {};
    list.forEach((c) => (map[c._id] = { ...c, children: [] }));
    const tree = [];
    list.forEach((c) => {
      if (c.parentId) map[c.parentId]?.children.push(map[c._id]);
      else tree.push(map[c._id]);
    });
    return tree;
  }
  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const res = await axios.get("/settings");
        setTitle(res.data.general?.siteName);
        setSiteLogo(res.data.general?.logo);
      } catch (err) {
        console.error("Error fetching site settings for tab title:", err);
      }
    };
    fetchSettings();
  }, []);
  // 🔍 جستجوی زنده (Autocomplete)
  useEffect(() => {
    const delayDebounce = setTimeout(async () => {
      if (searchText.trim().length < 2) {
        setSuggestions([]);
        return;
      }
      try {
        const res = await axios.get("/products", {
          params: {
            search: searchText,
            category: selectedCategory,
          },
        });
        setSuggestions(res.data.products || []);
        setShowSuggestions(true);
      } catch (error) {
        console.error("Error fetching suggestions:", error);
      }
    }, 400);

    return () => clearTimeout(delayDebounce);
  }, [searchText, selectedCategory]);

  const handleSearch = (text = searchText) => {
    if (!text.trim()) return;
    navigate(
      `/search?q=${encodeURIComponent(text)}${
        selectedCategory ? `&category=${selectedCategory}` : ""
      }`
    );
    setShowSuggestions(false);
  };

  const handleSuggestionClick = (product) => {
    navigate(`/product/${product.slug}`);
    setShowSuggestions(false);
  };

  // بستن لیست پیشنهادها با کلیک بیرون
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (!inputRef.current?.contains(e.target)) {
        setShowSuggestions(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // 🛒 شمارش سبد خرید
  useEffect(() => {
    if (!token) return;
    axios
      .get("/cart")
      .then((res) => {
        if (res.data?.items) {
          const total = res.data.items.reduce(
            (sum, item) => sum + item.quantity,
            0
          );
          setCartCount(total);
        }
      })
      .catch((err) => console.error("Error fetching cart count:", err));
  }, [token, cartItems]);

  const handleSelectCategory = (cat) => navigate(`/category/${cat._id}`);

  return (
    <header>
      <SideDrawer
        show={openSideDrawer}
        closeDrawer={() => setOpenSideDrawer(false)}
      />

      {/* ✅ Navbar اصلی */}
      <nav className="navbar navbar-expand-md navbar-dark bg-dark px-2">
        <div className="container-fluid d-flex justify-content-between align-items-center">
          {/* آیکون سبد خرید (موبایل) */}
          <div className="d-md-none">
            <Link
              to="/cart"
              className="btn btn-link position-relative text-white"
            >
              <i className="bi bi-cart3 fs-4"></i>
              {cartCount > 0 && (
                <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                  {cartCount}
                </span>
              )}
            </Link>
          </div>

          {/* لوگو */}
          <div className="d-flex align-items-center mx-auto mx-md-0">
            <Link
              className="navbar-brand d-flex align-items-center gap-2"
              to="/"
            >
              <img
                src={sitelogo ? `${sitelogo} ` : logo}
                alt="Logo"
                style={{ height: "40px" }}
              />
              <span className="fw-bold text-white">{title}</span>
            </Link>
          </div>

          {/* منوی موبایل */}
          <button
            className="navbar-toggler border-0 d-md-none text-white"
            type="button"
            onClick={() => setOpenSideDrawer(true)}
          >
            <FaBars size={22} />
          </button>

          {/* محتوا برای دسکتاپ */}
          <div className="collapse navbar-collapse d-none d-md-flex justify-content-between">
            <LinearLayout
              orientation="horizontal"
              xgravity="center"
              ygravity="center"
              width="match-parent"
              height="wrap-content"
              gap="5"
            >
              <ViewAllCategories tree={tree} onSelect={handleSelectCategory} />

              {/* 🔍 فرم جستجو */}
              <div
                className="position-relative w-100"
                ref={inputRef}
                style={{ width: "350px" }}
              >
                <div className="input-group">
                  <select
                    className="form-select"
                    style={{ maxWidth: "120px" }}
                    value={selectedCategory}
                    onChange={(e) => setSelectedCategory(e.target.value)}
                  >
                    <option value="">Categories</option>
                    {categories.map((cat) => (
                      <option key={cat._id} value={cat._id}>
                        {cat.name}
                      </option>
                    ))}
                  </select>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search"
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value)}
                    onKeyDown={(e) => e.key === "Enter" && handleSearch()}
                  />
                  <button
                    className="btn btn-success"
                    onClick={() => handleSearch()}
                  >
                    <FaSearch className="pb-1" />
                  </button>
                </div>

                {/* لیست پیشنهادها */}
                {showSuggestions && suggestions.length > 0 && (
                  <ul
                    className="list-group position-absolute w-100 mt-1 shadow-sm"
                    style={{
                      zIndex: 1000,
                      maxHeight: "300px",
                      overflowY: "auto",
                      borderRadius: "10px",
                    }}
                  >
                    {suggestions.map((item) => (
                      <li
                        key={item._id}
                        className="list-group-item list-group-item-action d-flex align-items-center"
                        onClick={() => handleSuggestionClick(item)}
                      >
                        <img
                          src={`${item.images?.[0]}`}
                          alt={item.title}
                          style={{
                            width: "40px",
                            height: "40px",
                            objectFit: "cover",
                            borderRadius: "6px",
                            marginLeft: "10px",
                          }}
                        />
                        <div>
                          <div className="fw-semibold">{item.title}</div>
                          <small className="text-muted">
                            {item.categoryId?.name || "Uncategorized"}
                          </small>
                        </div>
                      </li>
                    ))}
                  </ul>
                )}
              </div>

              {/* 🛒 دکمه‌ها */}
              <div className="d-flex  gap-2 w-100" dir="rtl">
                <Link to="/cart" className="position-relative">
                  <button className="btn btn-primary position-relative me-2">
                    <i className="bi bi-cart-fill"></i>
                    {cartCount > 0 && (
                      <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                        {cartCount}
                      </span>
                    )}
                  </button>
                </Link>

                {token ? (
                  <Link
                    to="/dashboard/profile"
                    className="btn btn-outline-light d-flex align-items-center gap-2"
                  >
                    <FaUserCircle size={20} />
                    <span>Profile</span>
                  </Link>
                ) : (
                  <button
                    className="btn btn-primary"
                    onClick={() => setShowModal(true)}
                  >
                    Login / SignUp
                  </button>
                )}
              </div>
            </LinearLayout>
          </div>
        </div>
      </nav>

      {/* 🔍 فرم جستجو مخصوص موبایل */}
      <div className="bg-light d-md-none p-2 border-top">
        <div className="d-flex" ref={inputRef}>
          <input
            className="form-control me-2"
            type="search"
            placeholder="Search"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && handleSearch()}
          />
          <button
            className="btn btn-outline-success"
            onClick={() => handleSearch()}
          >
            <FaSearch />
          </button>
        </div>
      </div>

      {/* 🔒 پنجره لاگین */}
      <Modal show={showModal} modalClosed={() => setShowModal(false)}>
        <Login />
      </Modal>
    </header>
  );
};

export default Toolbar;

// {
//
/* */
// }
/* <header className="Toolbar">
        <SideDrawer show={openSideDrawer} closeDrawer={closeDrawer} />
        <div className="menu-toggle bg-dark" onClick={DrawerHandler}></div>
        <span className="showNav"></span>
        <span className="showNav">
          <nav>
            <MenuItems />
          </nav>
        </span>
        <span className="showNav">
          <ButtonSimp
            margin="1"
            size="lg"
            padding="2"
            color="primary"
            text="ورود و ثبت نام"
            clicked={modalHandler}
          ></ButtonSimp>
        </span>

        <Modal show={showModal} modalClosed={modalClosed}>
          <SignIn />
        </Modal>

      </header> */

